import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PollIcon from "@material-ui/icons/Poll";
import SettingsIcon from "@material-ui/icons/Settings";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { colorPicker } from "../common";
import { buttonStyles, cardStyles } from "../styles";
import { ProgressBar } from "./ProgressBar";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { isMobileOnly } from 'react-device-detect';

export const FlashCardWidget = props => {
    
    const cards = cardStyles();
    const buttons = buttonStyles();

    let summary = `${props.deck.count} flashcards for ${props.deck.name}`;

    if (props.deck.summary !== '') {
        summary = props.deck.summary;
    }

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}
            maxWidth={props.maxWidth || "xs"}
            className={clsx(cards.deckContainer, colorPicker(props.deckColor))}
            style={{margin: "0 0 16px"}}
        >
            <Grid
                container={props.gridContainer || true}
                className={cards.gridContainer}
                alignContent={props.alignGrid || "stretch"}
                alignItems={props.alignGridItems || "stretch"}
                direction={props.gridDirection || "row"}
                item={props.gridItems || false}
                justify={props.justifyGrid || "flex-start"}
                lg={props.gridLG || false}
                md={props.gridMD || false}
                sm={props.gridSM || false}
                spacing={props.gridSpacing || 0}
                wrap={props.gridWrap || "wrap"}
                xl={props.gridXL || false}
                xs={props.gridXS || false}
                zeroMinWidth={props.gridZeroMinWidth || false}
            >
                <Grid item xs={12}>
                    <Typography
                        className={clsx(colorPicker(props.textColor), props.titleClass)}
                        variant={props.headerSize || "h4"}
                        align={props.headerAlign || "left"}
                        display={props.display || "initial"}
                        gutterBottom={props.gutterBottom || true}
                        noWrap={props.noWrap || false}
                        paragraph={props.paragraph || true}
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {props.deck.name || "Flashcard Deck #1"}
                    </Typography>
                </Grid>

                <div
                    style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "flex-start", flexDirection:"row", margin: "8px 0 0" }}
                >
                    <div style={{marginTop:"4px", display:"flex", flexDirection: "column", justifyContent: "flex-start", alignItems:  "flex-start", fontSize: "0.9em"}}>
                        <div className="margin-bottom-4">
                            {summary}
                        </div>
                    </div>

                    <Link
                        to={{
                            pathname: "/showFlashCard",
                            year: props.deck.year,
                            deckid: props.deck.deck                            
                        }}
                    >
                        <IconButton className={buttons.deckCardButtons} aria-label="go-deck">
                            <PlayCircleFilledIcon className={buttons.deckButtons} />
                        </IconButton>
                        <div className={buttons.deckCardButtonText}>
                            Start
                        </div>
                    </Link>
                </div>
            </Grid>
        </Container>
    );
};
